import { PurchaseCategory, ValidateFetchConfig } from "@/models";

export const camelCaseToTitle = (str: string) => {
  // Insert a space before any uppercase letters preceded by a lowercase letter
  const titleCase = str.replace(/([a-z])([A-Z])/g, "$1 $2");

  // Capitalize the first letter of each word
  const words = titleCase.split(" ");
  const capitalizedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1)
  );

  // Join the words back together
  const title = capitalizedWords.join(" ");

  return title;
};

export const getQueryStringValue = (key: string): string | null => {
  const url = window.location.href;
  const queryString = url.split("?")[1];
  if (!queryString) {
    return null;
  }
  const queryParams = new URLSearchParams(queryString);
  const value = queryParams.get(key);
  if (key === "tkn" && value) {
    return decodeURIComponent(value)?.replace(/\s/g, "+");
  }
  return value;
};

export const toCamelCase = (value: string) =>
  value.charAt(0).toUpperCase() + value.slice(1);

export const convertToMoney = (money: string): string => {
  return `₦${money.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
};

export const convertToMoneytoNGN = (money: string): string => {
  return `NGN ${money.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
};

export const formatDate = (date: Date) => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  const datePart = date.toLocaleDateString("en-US", options);

  return datePart.split("at");
};

export const formatReceiptdate = (dateString: string, seperate?: boolean) => {
  const dateObject = new Date(dateString);

  const day = String(dateObject.getDate()).padStart(2, "0");
  const month = dateObject.toLocaleString("default", { month: "long" });
  const year = dateObject.getFullYear();

  const hours = dateObject.getHours();
  const minutes = String(dateObject.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";

  const formattedDate = seperate
    ? `${month} ${day}, ${year}`
    : `${day}/${String(dateObject.getMonth() + 1).padStart(2, "0")}/${String(
        year
      ).slice(-2)}`;
  const formattedTime = `${hours}:${minutes} ${ampm.toUpperCase()}`;

  return seperate
    ? [formattedDate, formattedTime]
    : `${formattedDate} ${formattedTime}`;
};

export const generateArray = <T>(data: T | undefined): T => {
  if (data && Array.isArray(data)) {
    return data;
  } else {
    const defaultData = [] as any;
    return defaultData as T;
  }
};

export const GetEducationPurchaseCategory = (categoryName: string) => {
  if (categoryName?.toLowerCase()?.includes("waec")) {
    if (categoryName?.toLowerCase()?.includes("verification")) {
      return PurchaseCategory.WaecVerification;
    } else if (categoryName?.toLowerCase()?.includes("pin")) {
      return PurchaseCategory.WaecPin;
    } else if (categoryName?.toLowerCase()?.includes("registration")) {
      return PurchaseCategory.WaecRegistration;
    }
  } else if (categoryName?.toLowerCase()?.includes("jamb")) {
    return PurchaseCategory.Jamb;
  } else if (categoryName?.toLowerCase()?.includes("neco")) {
    return PurchaseCategory.Jamb;
  } else if (categoryName?.toLowerCase()?.includes("nabtech")) {
    return PurchaseCategory.Jamb;
  } else {
    return undefined;
  }
};

export const formatReceiptDate = (dateString: string, seperate?: boolean) => {
  const dateObject = new Date(dateString);

  const day = String(dateObject.getDate()).padStart(2, "0");
  const month = dateObject.toLocaleString("default", { month: "long" });
  const year = dateObject.getFullYear();

  const hours = dateObject.getHours();
  const minutes = String(dateObject.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";

  const formattedDate = seperate
    ? `${month} ${day}, ${year}`
    : `${day}/${String(dateObject.getMonth() + 1).padStart(2, "0")}/${String(
        year
      ).slice(-2)}`;
  const formattedTime = `${hours}:${minutes} ${ampm.toUpperCase()}`;

  return seperate
    ? [formattedDate, formattedTime]
    : `${formattedDate} ${formattedTime}`;
};

export const formatDateWithOrdinal = (dateInput: string | any): string => {
  let dateObject: Date;

  // Handle dayjs objects
  if (dateInput && typeof dateInput === "object" && dateInput.format) {
    dateObject = dateInput.toDate();
  } else if (typeof dateInput === "string") {
    dateObject = new Date(dateInput);
  } else {
    return dateInput; // Return original if not a valid date input
  }

  if (isNaN(dateObject.getTime())) {
    return dateInput; // Return original if invalid date
  }

  const day = dateObject.getDate();
  const month = dateObject.toLocaleString("default", { month: "long" });
  const year = dateObject.getFullYear();

  return `${month} ${day}, ${year}`;
};

export const formatDateWithTime = (dateInput: string | any): string => {
  let dateObject: Date;

  // Handle dayjs objects
  if (dateInput && typeof dateInput === "object" && dateInput.format) {
    dateObject = dateInput.toDate();
  } else if (typeof dateInput === "string") {
    dateObject = new Date(dateInput);
  } else {
    return dateInput; // Return original if not a valid date input
  }

  if (isNaN(dateObject.getTime())) {
    return dateInput; // Return original if invalid date
  }

  const day = dateObject.getDate();
  const month = dateObject.toLocaleString("default", { month: "long" });
  const year = dateObject.getFullYear();

  // Format time
  const hours = dateObject.getHours();
  const minutes = String(dateObject.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  const displayHours = hours % 12 || 12;

  return `${month} ${day}, ${year} ${displayHours}:${minutes} ${ampm}`;
};

export const validatePhoneNumber = (
  value: string,
  config?: ValidateFetchConfig
): string | null => {
  const phoneRegex = /^\d{10}$/;
  if (!value || phoneRegex.test(value)) {
    if (config?.validateNetworkNumber && config.network) {
      const { network } = config;
      if (network?.toLowerCase()?.includes("mtn")) {
        const mtnRegex =
          /^(234|0)((703|706|803|806|810|813|814|816|903|906|913|916|704|707)(\d{7})|(7025|7026)(\d{6}))$/;
        if (!mtnRegex.test(`0${value}`)) {
          return "Input a valid MTN number";
        }
      } else if (network?.toLowerCase()?.includes("airtel")) {
        const airtelRegex =
          /^(234|0)(701|708|802|808|812|901|902|904|907|912|911)(\d{7})$/;
        if (!airtelRegex.test(`0${value}`)) {
          return "Input a valid Airtel number";
        }
      } else if (network?.toLowerCase()?.includes("glo")) {
        const gloRegex = /^(234|0)(705|805|807|811|815|905|915)(\d{7})$/;
        if (!gloRegex.test(`0${value}`)) {
          return "Input a valid Glo number";
        }
      } else if (network?.toLowerCase()?.includes("9mobile")) {
        const nineMobileRegex = /^(234|0)(809|817|818|908|909)(\d{7})$/;
        if (!nineMobileRegex.test(`0${value}`)) {
          return "Input a valid 9mobile number";
        }
      }
    }
    return null;
  }
  return "Please input a valid phone number";
};
